import productionMeta from '@/router/production/productionMeta'
import register from '@/router/production/register'
import template from '@/router/production/template'
import productionRedirect from '@/router/production/productionRedirect'

export default [
  // Заказы
  {
    path: '/production',
    name: 'Production',
    meta: productionMeta,
    redirect: productionRedirect,
    component: () => import('@/views/Production/Production.vue'),
    children: [
      ...register,
      ...template,
      {
        path: 'change-log',
        name: 'ChangeLog',
        meta: productionMeta,
        component: () => import('@/views/Production/ChangeLog.vue')
      }
    ]
  }
]
